import { Injectable } from '@angular/core';

@Injectable()
export class StringUtilsService {

  constructor() { }

  removeAcento(texto: string) {
    return texto.toLowerCase()
      .replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
      .replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
      .replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
      .replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
      .replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
      .replace(new RegExp('[Ç]', 'gi'), 'c');
  }

  textoParaSlug(texto: string = '') {
    return this.removeAcento(
      texto
        .trim()
        .toLowerCase()
        .replace(/\s/ig, '-')
        .replace(/\(|\)|\./g, ''),
    );
  }

  urlParaArray(url) {
    return url.substr(1).split('/');
  }

  compactarNome(nome: string): string {
    if (nome.length <= 20) {
      return nome;
    }

    return nome
      .split(' ')
      .filter(palavra => palavra.length > 2)
      .map(palavra => palavra.charAt(0))
      .join('');
  }

  convertPontuacaoEnem(pontuacao: string) {
    if (!pontuacao) {
      return null;
    }
    const somentePontuacao = pontuacao.replace(/[,]+/g, '.');
    return Number(somentePontuacao);
  }

  getAnoEnem(ano: string) {
    if (!ano) {
      return null;
    }
    return Number(ano);
  }
}
